import { AppServicesLibraryService } from 'app-services-library';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as frmSubTaskDetailsAction from '../actions/sub-task-details.actions';


@Injectable()
export class SubTaskDetailsEffects {

  constructor(
    private actions$: Actions,
    private appServicesLibraryService: AppServicesLibraryService
  ) { }

  subTaskDetailsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(frmSubTaskDetailsAction.loadSubTaskDetails),
      mergeMap((action) => this.appServicesLibraryService
        .getTask('I140', action.taskId)
        .pipe(
          map(details => ({ type: '[SubTaskDetails] Load I140 SubTaskDetails Success', details })),
          catchError((error) => of({ type: '[SubTaskDetails] Load I140 SubTaskDetails Failure', payload: error }))
        )));
  });

}
